module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ant Design Plus","short_name":"AntD Plus","description":"react components","start_url":"/","background_color":"#f7f7f7","theme_color":"#1890ff","display":"standalone","icon":"src/images/favicon.png"},
    },{
      plugin: require('/opt/build/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
